<div class="modal-content">
  <app-loader-circles *ngIf="loading"></app-loader-circles>

<div class="modal-header text-center" *ngIf="metodosAssinatura.length > 1">
  <h3 class="modal-title">ASSINATURA DIGITAL</h3>
  {{ assinaturaIndividual ? 'Como seu cliente deseja assinar estes documentos?' : 'Como seu cliente e os avalistas irão assinar estes documentos' }}
</div>
<div class="modal-body text-center">
  <section class="opcao" *ngIf="possuiAssinatura('SMS')">
    <h3>Via Celular</h3>
    <div class="conteudo" *ngIf="assinaturaIndividual">
      O Cliente irá receber uma mensagem no celular cadastrado <br>
      <strong>({{ signatarios[0]?.ddd }} {{ signatarios[0]?.telefone }})</strong><br>
      com as informações do contrato e como assina-lo.
    </div>
    <div class="conteudo" *ngIf="!assinaturaIndividual">
      O Cliente e os avalistas irão receber uma mensagem com as informações do contrato e como assina-lo, nos celulares cadastrados:<br>
      <div *ngFor="let signatario of signatarios" >
        {{ signatario.nome }}: <strong>({{ signatario.ddd }} {{ signatario.telefone }})</strong><br>
        <a (click)="resendToken(signatario, 1)" *ngIf="enviouSms">Não chegou? Reenviar!</a>
      </div>
    </div>
    <div class="action">
        <app-animated-button
          label="Enviar Mensagem"
          afterLabel="Enviado!"
          [onclick]="sendSms.bind(this)"
          [onerror]="showError"
          [animated]="false"
          [wasExecuted]="enviouSms"></app-animated-button>
        <a (click)="resendToken(signatarios[0], 1)" *ngIf="assinaturaIndividual && enviouSms">Não chegou? Reenviar!</a>
    </div>
  </section>

  <section class="opcao" *ngIf="possuiAssinatura('EMAIL')">
    <h3>Via E-mail</h3>
    <div class="conteudo" *ngIf="assinaturaIndividual">
      O Cliente irá receber um link, no e-mail cadastrado <br>
      <strong>({{ signatarios[0]?.email }})</strong><br>
      com as informações do contrato e como assina-lo.
    </div>
    <div class="conteudo" *ngIf="!assinaturaIndividual">
      O Cliente e os avalistas irão receber uma link com as informações do contrato e como assina-lo, nos e-mails cadastrados:<br>
      <div *ngFor="let signatario of signatarios" >
        {{ signatario.nome }}: <strong>({{ signatario.email }})</strong><br>
        <a (click)="alterarEmail(signatario)" *ngIf="!enviouEmail">Não é este e-mail? Alterar</a>
        <a (click)="resendToken(signatario, 2)" *ngIf="enviouEmail">Não chegou? Reenviar!</a>
      </div>
    </div>
    <div class="action">
      <app-animated-button
        label="Enviar E-mail"
        afterLabel="Enviado!"
        [onclick]="sendEmail.bind(this)"
        [onerror]="showError"
        [animated]="false"
        [wasExecuted]="enviouEmail"></app-animated-button>
      <a (click)="alterarEmail(signatarios[0])" *ngIf="assinaturaIndividual && !enviouEmail">Não é este e-mail? Alterar</a>
      <a (click)="resendToken(signatarios[0], 2)" *ngIf="assinaturaIndividual && enviouEmail">Não chegou? Reenviar!</a>
    </div>
  </section>

<div class="modal-footer">
  <button class="btn btn-border-orange" (click)="close()">Voltar</button>
</div>
</div>
